import './App.css';
import 'services/ThemeService';
import 'toast-eduzz/dist/toast-eduzz.min.css';

import AlertComponent from 'components/AlertComponent';
import LoaderComponent from 'components/LoaderComponent';
import PixelComponent from 'components/PixelComponent';
import Scripts from 'components/Scripts';
import { blue } from '@material-ui/core/colors';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import CartPage from './components/Cart';
import ThankYouPage from './components/ThankYouPage';
import ToastProducer from './components/ToastProducer';
import CssBaseline from '@material-ui/core/CssBaseline';
import Error from './components/Error';
import Captcha from './components/Captcha/index';
import InternetStatus from 'components/InternetStatus';
import Shopback from 'components/Scripts/Shopback';

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Lato, Helvetica, Arial, sans-serif',
    useNextVariants: true,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 700
  },
  palette: {
    primary: {
      50: '#e8f5e9',
      100: '#c8e6c9',
      200: '#a5d6a7',
      300: '#81c784',
      400: '#66bb6a',
      500: '#4caf50',
      600: '#43a047',
      700: '#388e3c',
      800: '#2e7d32',
      900: '#1b5e20',
      A100: '#b9f6ca',
      A200: '#69f0ae',
      A400: '#00e676',
      A700: '#00c853',
      contrastText: '#fff'
    },
    secondary: blue,
    background: {
      default: '#fff'
    },
  },
  overrides: {
    MuiButton: {
      root: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
        '&:focus': {
          boxShadow: 'none',
        }
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
        '&:focus': {
          boxShadow: 'none',
        }
      }
    }
  }
});
interface IState {
  loaded: boolean;
}

class App extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = { loaded: false };
  }

  componentDidMount() {
    this.setState({ loaded: true });
  }

  toHome = () => {
    return <Redirect to='/' />;
  }

  render() {
    const { loaded } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <InternetStatus />
        <Captcha />
        <LoaderComponent />
        <AlertComponent />
        <Scripts />
        <ToastProducer />
        <Shopback />
        <PixelComponent />

        <div className='content'>
          {loaded &&
            <Router>
              <Switch>
                <Route exact path='/thankyou/:id/:key' component={ThankYouPage} />
                <Route exact path='/pixel/:id' component={undefined} />
                <Route path='/:id' component={CartPage} />
                <Route exact path='/' component={Error} />
                <Route render={this.toHome} />
              </Switch>
            </Router>
          }
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx